import { useGetData } from 'src/hooks/useGetData'
import configApi from 'src/api/configApi'
import { useMemo } from 'react'

const useGetTeacherLevels = () => {
  const { data: teacherLevels } = useGetData(configApi.getListSalaryGroup)

  return useMemo(() => {
    if (teacherLevels) {
      return teacherLevels
        .sort((a, b) => (a?.position || 1000) - (b?.position || 1000))
        .map((val) => ({
          value: val?.id,
          label: val?.name
        }))
    }
    return []
  }, [teacherLevels])
}
export default useGetTeacherLevels
